/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../../../common/AppStack';
import AppText from '../../../../common/AppText';
import AppFlexbox from '../../../../common/AppFlexbox';
import { isVariantOptionUnavailable } from '../../../../../helpers/webstoreHelper';
import WsColorSwatch from './WsColorSwatch';

const WsVariantColorPicker = ({
  ecomStoreProduct,
  selectedVariant,
  selectedOptions,
  onVariantChange,
  colorOption,
  disabled
}) => {
  const selectedVariantColor = selectedVariant
    ? selectedVariant.ecomVendorProductVariant.ecomVendorProductVariantOptions.find(
        (so) => so.nameSort === colorOption.sort && so.name === colorOption.name
      )?.value
    : null;

  return (
    colorOption && (
      <AppStack style={{ gap: 5 }}>
        <AppText style={{ fontSize: 14, fontWeight: 500 }}>
          {colorOption.name}
          {selectedVariantColor ? `: ${selectedVariantColor}` : ''}
        </AppText>

        <AppFlexbox style={{ gap: 8, flexWrap: 'wrap' }}>
          {colorOption.values.map((v) => {
            const variants = ecomStoreProduct?.ecomStoreProductVariants.filter(
              (variant) =>
                variant.ecomVendorProductVariant.ecomVendorProductVariantOptions.some(
                  (so) =>
                    so.nameSort === colorOption.sort &&
                    so.name === colorOption.name &&
                    so.value === v.value
                )
            );

            const color1 =
              variants[0]?.ecomVendorProductVariant.primaryColor || '#FFF';
            const color2 = variants[0]?.ecomVendorProductVariant.secondaryColor;
            const isOptionSelected = variants.some(
              (variant) =>
                variant.pkEcomStoreProductVariant ===
                selectedVariant?.pkEcomStoreProductVariant
            );

            const isColorDisabled = isVariantOptionUnavailable(
              colorOption,
              v.value,
              selectedOptions,
              ecomStoreProduct
            );

            return (
              <WsColorSwatch
                key={v.value}
                disabled={disabled}
                isColorDisabled={isColorDisabled}
                onClick={() => {
                  if (!isColorDisabled && !disabled) {
                    onVariantChange(ecomStoreProduct.pkEcomStoreProduct, [
                      ...selectedOptions.filter(
                        (f) => f.name !== colorOption.name
                      ),
                      {
                        nameSort: colorOption.sort,
                        name: colorOption.name,
                        value: v.value
                      }
                    ]);
                  }
                }}
                primaryColor={color1}
                secondaryColor={color2}
                selected={isOptionSelected}
                value={v.value}
              />
            );
          })}
        </AppFlexbox>
      </AppStack>
    )
  );
};

WsVariantColorPicker.propTypes = {
  colorOption: PropTypes.object,
  disabled: PropTypes.bool,
  ecomStoreProduct: PropTypes.object,
  onVariantChange: PropTypes.func,
  selectedOptions: PropTypes.array,
  selectedVariant: PropTypes.object
};

export default WsVariantColorPicker;
